<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Package Standard Sub-Item Text</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Package Standard Sub-Item Text</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">View Existing Package Standard Sub-Item Text</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="form.subItemNo"
                  :label="label.subItemNo"
                  :error-messages="errors.collect('subItemNo')"
                  data-vv-name="subItemNo"
                  :data-vv-as="label.subItemNo"
                  v-validate="subItemNoValidation"
                  @blur="checkSubItemNo"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ label.subItemNo }}</v-subheader>
                <div class="queryValue">{{ form.subItemNo }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <v-text-field
                  v-model="form.subItemDesc"
                  :label="label.subItemDesc"
                  :error-messages="errors.collect('subItemDesc')"
                  data-vv-name="subItemDesc"
                  :data-vv-as="label.subItemDesc"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ label.subItemDesc }}</v-subheader>
                <div class="queryValue">{{ form.subItemDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-spacer class="mt-3"></v-spacer>
          <v-layout>
            <v-flex xs6>
              <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
                Cancel
                <v-icon right dark>mdi-cancel</v-icon>
              </v-btn>
              <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click.prevent="doSave" :loading="submitting">
                Save
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'
import { removeFormatNumber } from '@/utils/number.js'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      submitting: false,
      newMode: false,
      queryMode: false,
      reviewMode: false,
      seqSubItemNo: '1',
      label: {
        subItemNo: 'Sub-Item No.',
        subItemDesc: 'Sub-Item Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        subItemNo: null,
        subItemDesc: null,
        createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      today: new Date(),
      loading: false
    }
  },
  methods: {
    async doInit() {
      await this.$store.dispatch('pkgStdSubItemTxtInit')
      this.form.scheme = this.pkgStdSubItemTxtId.scheme
      this.form.riskNo = this.pkgStdSubItemTxtId.riskNo
      this.form.itemNo = this.pkgStdSubItemTxtId.itemNo
      if (this.newTranMode) {
        this.form.subItemNo = '1'
        this.form.createdDate = new Date()
      } else {
        this.fetchData()
      }
    },
    doCancel() {
      this.$router.push({ name: 'pkgStdSubItemTxt' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createPkgStdSubItemTxt
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'pkgStdSubItemTxt' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updatePkgStdSubItemTxt
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'pkgStdSubItemTxt' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async fetchData() {
      const apiURI = this.menu.getPkgStdSubItemTxt
      if (apiURI) {
        try {
          const expand = {
            scheme: this.pkgStdSubItemTxtId.scheme,
            riskNo: this.pkgStdSubItemTxtId.riskNo,
            itemNo: this.pkgStdSubItemTxtId.itemNo,
            subItemNo: this.pkgStdSubItemTxtId.subItemNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.subItemNo = data.pkgStdSubItemTxt.subItemNo
            this.form.subItemDesc = data.pkgStdSubItemTxt.subItemDesc
            this.form.createdBy = data.createdBy
            this.form.createdDate = data.createdDate
            this.form.modifiedBy = data.modifiedBy
            this.form.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    formatDisplayDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    async checkSubItemNo() {
      const apiUrl = this.menu.checkSubItemNo
      if (apiUrl) {
        try {
          const expand = {
            scheme: this.pkgStdSubItemTxtId.scheme,
            riskNo: this.pkgStdSubItemTxtId.riskNo,
            itemNo: this.pkgStdSubItemTxtId.itemNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.seqSubItemNo = data.subItemNo
          }
          return true
        } catch (err) {
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('pkgStdItemTxt'))
    this.$store.commit('PKGSTDITEMTXT_COMMIT_KEY', jsonData)

    const jsonData2 = JSON.parse(sessionStorage.getItem('pkgStdSubItemTxt'))
    this.$store.commit('PKGSTDSUBITEMTXT_COMMIT_KEY', jsonData2)

    if (this.pkgStdSubItemTxtId.tranMode !== '') {
      if (this.pkgStdSubItemTxtId.tranMode === 'New') {
        this.newMode = true
      } else if (this.pkgStdSubItemTxtId.tranMode === 'Review') {
        this.reviewMode = true
      } else if (this.pkgStdSubItemTxtId.tranMode === 'Query') {
        this.queryMode = true
      }
    }

    const mustGreaterThenZero = {
      getMessage: (field, args) => {
        return field + ' cannot be 0'
      },
      validate: (value, args) => {
        return removeFormatNumber(value) >= 0.000001
      }
    }
    this.$validator.extend('mustGreaterThenZero', mustGreaterThenZero)

    this.$validator.extend('valSubItemNo', {
      getMessage(field, args) {
        return 'Duplicated record or Sub-Item No. is not in sequence! Please change the primary key in sequence start from: ' + args
      },
      validate(value, args) {
        if (args === void 0) args = []
        var subItemNoVal = args[0]
        if (subItemNoVal === value) {
          return true
        } else {
          return false
        }
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.pkgStdSubItemTxt.menu
    },
    newTranMode() {
      return this.pkgStdSubItemTxtId.tranMode === 'New'
    },
    pkgStdItemTxtId() {
      return this.$store.state.pkgParam.pkgStdItemTxt.pkgStdItemTxtId
    },
    pkgStdSubItemTxtId() {
      return this.$store.state.pkgParam.pkgStdSubItemTxt.pkgStdSubItemTxtId
    },
    subItemNoValidation() {
      return 'required|numeric|mustGreaterThenZero|valSubItemNo:' + this.seqSubItemNo
    }
  },
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>
